<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label ="Test step details">
        <dpi-test-step-details> </dpi-test-step-details>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{pictureNum}}" [matBadgeHidden]="pictureNum === 0" matBadgeOverlap="false" class="tab_step_badge">Pictures</span>
        </ng-template>
        <dpi-test-step-picture (listSizeChanged)="setPictureNum($event)"> </dpi-test-step-picture>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{stepRecomNum}}" [matBadgeHidden]="stepRecomNum === 0" matBadgeOverlap="false" class="tab_step_recom_badge">Recommendation</span>
        </ng-template>
        <dpi-test-step-recom (listSizeChanged)="setStepRecomNum($event)"></dpi-test-step-recom>
    </mat-tab>
</mat-tab-group>
